
import React, {Component} from 'react'
import PropTypes from 'prop-types'

const CLASS_NAME = 'octicon octicon-plus-small'
class PlusSmallIcon extends Component {
  render() {
    let defaults = {
      height: 16,
      width: 7,
      viewBox: '0 0 7 16',
      'aria-hidden': true
    }

    let {className, size} = this.props
    if (className) {
      className = CLASS_NAME + ' ' + className
    } else {
      className = CLASS_NAME
    }

    if (size === 'mega') {
      defaults.height *= 2
      defaults.width *= 2
    }

    return (
      <svg {...defaults} {...this.props} className={className}>
        <path fillRule="evenodd" d="M4 7V4H3v3H0v1h3v3h1V8h3V7H4z"/>
      </svg>
    )
  }
}
PlusSmallIcon.propTypes = {
  className: PropTypes.string
}
export default PlusSmallIcon
